export default function AttemptDots({ count }) {
  if (!count || count <= 1) return null;
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }, (_, i) => (
        <span key={i}>
          {i < count - 1 ? (
            <>
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-navy" />
              <span className="inline-block h-px w-2 bg-navy/30" />
            </>
          ) : (
            <span className="inline-block h-2 w-2 rounded-full bg-gold ring-1 ring-gold/30" />
          )}
        </span>
      ))}
      <span className="ml-1 text-[10px] font-semibold text-navy">#{count}</span>
    </div>
  );
}
